import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { PosthogService } from './posthog.service';

@NgModule()
export class PosthogModule {
  static forRoot(): ModuleWithProviders<PosthogModule> {
    return {
      ngModule: PosthogModule,
      providers: [
        provideAppInitializer(() => {
          inject(PosthogService).initialize();
        })
      ]
    };
  }
}
